export { default } from './UserInfoBlock';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyPage/UserInfoBlock/index.js